import React from 'react';
import { inject, observer } from "mobx-react/index";
import alasql from 'alasql';
import XLSX from 'xlsx';
import AnalysysDataViewTableParameterStation from "./AnalysysDataViewTableParameterStation";
import AnalysysDataViewTableStationParameter from "./AnalysysDataViewTableStationParameter";

alasql.utils.isBrowserify = false;
alasql.utils.global.XLSX = XLSX;

@inject('stationStore', 'parameterStore')
@observer
class AnalysisDataViewTable extends React.Component {
  render() {
    const { stationStore, stations, parameters, parameterStore, selectedStations, selectedParameters, onChangeSelectedParameter, onChangeSelectedStations, showStationParameter, func, setShowStationParameter } = this.props;

    func.sort((a, b) => {
      if (a > b)
        return 1;
      else if (a < b)
        return -1;
      else
        return 0;
    });

    // const {showStationParameter} = this.state;
    // console.log(stations)
    return (
      <div style={{ margin: '0 25px 25px 25px' }}>
        <div className='outer' style={{ margin: '10px -25px 0 -25px' }}>
          <div className='inner' style={{ marginLeft: '240px' }}>
            <table className='horizontal' style={{ maxHeight: '100%', width: 'unset' }}>
              <thead>
                <tr style={{ height: '40px' }}>
                  <th style={{ width: '20px', height: '40px', paddingTop: '25px' }}><i className='fa fa-exchange white' onClick={() => setShowStationParameter(!showStationParameter)} style={{ fontSize: '16px' }} /></th>
                  <th style={{ left: '30px', width: '200px', height: '40px', paddingTop: 0, paddingBottom: 0 }}><input defaultChecked={true} type='checkbox' style={{ margin: '10px' }} onChange={(e) => onChangeSelectedStations(stations, e.target.checked)} />All Stations</th>
                  {/*<td style={{width: '160px', height: '30px'}}>Time</td>*/}
                  {showStationParameter ?
                    func && func.length > 0 ?
                      parameters.map(item =>
                        func.map(i => <td key={`analysis-table-column-parameter-${item}-${i}-header`} style={{ textAlign: 'center', height: '35px', padding: 0 }}><div style={{ width: '60px' }}>{parameterStore.findById(item).code} ({i})</div></td>)
                      ).reduce((acc, val) => {
                        return [...acc, ...val];
                      }, []) :
                      parameters.map(item => <td key={`analysis-table-column-parameter-${item}-header`} style={{ textAlign: 'center', height: '35px', padding: 0 }}><div style={{ width: '60px' }}>{parameterStore.findById(item).code}</div></td>) :
                    stations.map(id => <td key={`analysis-table-column-station-${id}-header`} style={{ textAlign: 'center', height: '35px', padding: 0 }}><div style={{ width: '130px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }} data-toggle='tooltip' title={stationStore.findById(id).name}>{stationStore.findById(id).name}</div></td>)
                  }
                </tr>
                <tr style={{ height: '35px' }}>
                  {/*<th style={{width: '20px', height: '35px', paddingTop: 0, paddingBottom: 0}}>{}</th>*/}
                  <th style={{ left: '30px', width: '200px', height: '35px', paddingTop: 0, paddingBottom: 0 }}><input defaultChecked={true} type='checkbox' style={{ margin: '10px' }} onChange={(e) => onChangeSelectedParameter(parameters, e.target.checked)} />All Parameters</th>
                  {/*<td style={{width: '160px', height: '30px'}}>{}</td>*/}
                  {showStationParameter ?
                    func && func.length > 0 ?
                      parameters.map(item =>
                        func.map(i => <td key={`analysis-table-column-parameter-${item}-${i}-checkbox`} style={{ height: '30px', padding: 0 }}><input type='checkbox' style={{ width: '60px' }} checked={selectedParameters[item]} onChange={() => onChangeSelectedParameter(item)} /></td>)
                      ).reduce((acc, val) => {
                        return [...acc, ...val];
                      }, []) :
                      parameters.map(item => <td key={`analysis-table-column-parameter-${item}-checkbox`} style={{ height: '30px', padding: 0 }}><input type='checkbox' style={{ width: '60px' }} checked={selectedParameters[item]} onChange={() => onChangeSelectedParameter(item)} /></td>) :
                    stations.map(item => <td key={`analysis-table-column-station-${item}-checkbox`} style={{ height: '30px', padding: 0 }}><input type='checkbox' style={{ width: '130px' }} checked={selectedStations[item]} onChange={() => onChangeSelectedStations(item)} /></td>)
                  }
                </tr>
              </thead>
              {showStationParameter ?
                <AnalysysDataViewTableStationParameter
                  {...this.props}
                /> :
                <AnalysysDataViewTableParameterStation
                  {...this.props}
                />}
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default AnalysisDataViewTable;


// WEBPACK FOOTER //
// ./src/components/Analysis/Data/AnalysisDataViewTable.js